export const BUT_STORES = [
  { externalId: "258", label: "BUT ABBEVILLE" },
  { externalId: "001", label: "BUT AGDE" },
  { externalId: "002", label: "BUT AGEN" },
  { externalId: "003", label: "BUT AJACCIO" },
  { externalId: "396", label: "BUT ALBERT" },
  { externalId: "004", label: "BUT ALBERTVILLE" },
  { externalId: "005", label: "BUT ALBI" },
  { externalId: "277", label: "BUT ALENCON" },
  { externalId: "007", label: "BUT ALÈS" },
  { externalId: "008", label: "BUT AMBERIEU EN BUGEY" },
  { externalId: "513", label: "BUT AMBERT" },
  { externalId: "294", label: "BUT AMBOISE" },
  { externalId: "009", label: "BUT AMIENS" },
  { externalId: "289", label: "BUT ANCENIS" },
  { externalId: "010", label: "BUT ANGERS" },
  { externalId: "011", label: "BUT ANGOULÊME" },
  { externalId: "012", label: "BUT ANNECY" },
  { externalId: "013", label: "BUT ANNEMASSE" },
  { externalId: "295", label: "BUT ARGENTAN" },
  { externalId: "015", label: "BUT ARLES" },
  { externalId: "016", label: "BUT ARRAS" },
  { externalId: "134", label: "BUT AUBAGNE/MARSEILLE" },
  { externalId: "017", label: "BUT AUBENAS" },
  { externalId: "018", label: "BUT AULNAY SOUS BOIS" },
  { externalId: "019", label: "BUT AURILLAC" },
  { externalId: "341", label: "BUT AUTUN" },
  { externalId: "247", label: "BUT AUXERRE" },
  { externalId: "384", label: "BUT AVALLON" },
  { externalId: "020", label: "BUT AVIGNON" },
  { externalId: "283", label: "BUT AVRANCHES" },
  { externalId: "021", label: "BUT BAGNOLS SUR CÈZE" },
  { externalId: "514", label: "BUT BAIN DE BRETAGNE" },
  { externalId: "276", label: "BUT BAR LE DUC" },
  { externalId: "272", label: "BUT BAR SUR AUBE" },
  { externalId: "188", label: "BUT BARENTIN/ROUEN" },
  { externalId: "022", label: "BUT BASTIA" },
  { externalId: "279", label: "BUT BAYEUX" },
  { externalId: "023", label: "BUT BAYONNE" },
  { externalId: "502", label: "BUT BEAUCAIRE" },
  { externalId: "290", label: "BUT BEAUFORT" },
  { externalId: "282", label: "BUT BEAUNE" },
  { externalId: "024", label: "BUT BEAUVAIS" },
  { externalId: "147", label: "BUT BELFORT" },
  { externalId: "522", label: "BUT BELLEY" },
  { externalId: "025", label: "BUT BERGERAC" },
  { externalId: "284", label: "BUT BERNAY" },
  { externalId: "360", label: "BUT BESANÇON SUD" },
  { externalId: "246", label: "BUT BIGANOS" },
  { externalId: "029", label: "BUT BLOIS" },
  { externalId: "259", label: "BUT BOLLÈNE" },
  { externalId: "031", label: "BUT BORDEAUX/ARTIGUES" },
  { externalId: "032", label: "BUT BORDEAUX/CADAUJAC" },
  { externalId: "033", label: "BUT BORDEAUX/MERIGNAC" },
  { externalId: "034", label: "BUT BOULOGNE SUR MER" },
  { externalId: "035", label: "BUT BOURG EN BRESSE" },
  { externalId: "036", label: "BUT BOURGES" },
  { externalId: "037", label: "BUT BOURGOIN" },
  { externalId: "269", label: "BUT BOURGUIGNON" },
  { externalId: "038", label: "BUT BRESSUIRE" },
  { externalId: "039", label: "BUT BREST" },
  { externalId: "040", label: "BUT BRIOUDE" },
  { externalId: "041", label: "BUT BRIVE" },
  { externalId: "027", label: "BUT BÉTHUNE" },
  { externalId: "028", label: "BUT BÉZIERS" },
  { externalId: "135", label: "BUT CABRIES/MARSEILLE" },
  { externalId: "042", label: "BUT CAEN" },
  { externalId: "043", label: "BUT CAHORS" },
  { externalId: "044", label: "BUT CALAIS" },
  { externalId: "518", label: "BUT CAMBRAI" },
  { externalId: "046", label: "BUT CANNES" },
  { externalId: "387", label: "BUT CAPVERN" },
  { externalId: "047", label: "BUT CARCASSONNE" },
  { externalId: "048", label: "BUT CARENTAN" },
  { externalId: "049", label: "BUT CARHAIX" },
  { externalId: "326", label: "BUT CASTELSARRASIN" },
  { externalId: "050", label: "BUT CASTRES" },
  { externalId: "052", label: "BUT CHALON SUR SAÔNE" },
  { externalId: "053", label: "BUT CHALONS EN CHAMPAGNE" },
  { externalId: "274", label: "BUT CHAMPAGNOLE" },
  { externalId: "296", label: "BUT CHANTONNAY" },
  { externalId: "374", label: "BUT CHARANCIEU" },
  { externalId: "055", label: "BUT CHARLEVILLE MEZIÈRES" },
  { externalId: "056", label: "BUT CHARTRES" },
  { externalId: "285", label: "BUT CHATEAU D'OLONNE" },
  { externalId: "306", label: "BUT CHATEAU GONTIER" },
  { externalId: "058", label: "BUT CHATEAUDUN" },
  { externalId: "060", label: "BUT CHATEAUROUX" },
  { externalId: "061", label: "BUT CHATELLERAULT" },
  { externalId: "062", label: "BUT CHAUMONT" },
  { externalId: "327", label: "BUT CHAUVIGNY" },
  { externalId: "064", label: "BUT CHERBOURG" },
  { externalId: "291", label: "BUT CHINON" },
  { externalId: "065", label: "BUT CHOLET" },
  { externalId: "373", label: "BUT CHÂTEAU THIERRY" },
  { externalId: "057", label: "BUT CHÂTEAUBRIANT" },
  { externalId: "351", label: "BUT CLAYE SOUILLY" },
  { externalId: "066", label: "BUT CLERMONT FERRAND NORD" },
  { externalId: "067", label: "BUT CLERMONT FERRAND SUD" },
  { externalId: "317", label: "BUT CLERMONT L'HERAULT" },
  { externalId: "318", label: "BUT CLISSON" },
  { externalId: "068", label: "BUT CLUSES" },
  { externalId: "069", label: "BUT COGNAC" },
  { externalId: "349", label: "BUT COLMAR" },
  { externalId: "275", label: "BUT CONFLANS" },
  { externalId: "383", label: "BUT COSNE SUR LOIRE" },
  { externalId: "319", label: "BUT COULOMMIERS" },
  { externalId: "297", label: "BUT COUTANCES" },
  { externalId: "073", label: "BUT CREIL" },
  { externalId: "389", label: "BUT CREST" },
  { externalId: "255", label: "BUT CRÉTEIL" },
  { externalId: "074", label: "BUT DAX" },
  { externalId: "075", label: "BUT DIEPPE" },
  { externalId: "076", label: "BUT DIGNE" },
  { externalId: "077", label: "BUT DIGOIN" },
  { externalId: "078", label: "BUT DIJON" },
  { externalId: "079", label: "BUT DINAN" },
  { externalId: "320", label: "BUT DIVES SUR MER" },
  { externalId: "080", label: "BUT DOLE" },
  { externalId: "262", label: "BUT DOMMARTIN LES TOUL" },
  { externalId: "250", label: "BUT DOMUS (ROSNY SOUS BOIS)" },
  { externalId: "361", label: "BUT DOMUS KITCHEN" },
  { externalId: "346", label: "BUT DOUAI" },
  { externalId: "081", label: "BUT DREUX" },
  { externalId: "506", label: "BUT ENGLOS" },
  { externalId: "082", label: "BUT EPERNAY" },
  { externalId: "083", label: "BUT EPINAL" },
  { externalId: "307", label: "BUT EU" },
  { externalId: "084", label: "BUT EVREUX" },
  { externalId: "353", label: "BUT EZANVILLE" },
  { externalId: "085", label: "BUT FIGEAC" },
  { externalId: "086", label: "BUT FOIX" },
  { externalId: "087", label: "BUT FONTENAY LE COMTE" },
  { externalId: "089", label: "BUT FOUGÈRES" },
  { externalId: "090", label: "BUT FOURMIES" },
  { externalId: "092", label: "BUT FRESNES" },
  { externalId: "091", label: "BUT FRÉJUS" },
  { externalId: "528", label: "BUT GAILLAC" },
  { externalId: "093", label: "BUT GAP" },
  { externalId: "321", label: "BUT GENESTON" },
  { externalId: "342", label: "BUT GENNEVILLIERS" },
  { externalId: "298", label: "BUT GIEN" },
  { externalId: "308", label: "BUT GISORS" },
  { externalId: "095", label: "BUT GRANVILLE" },
  { externalId: "096", label: "BUT GRAY" },
  { externalId: "527", label: "BUT GOURDAN-POLIGNAN" },
  { externalId: "097", label: "BUT GRENOBLE EYBENS" },
  { externalId: "356", label: "BUT GRENOBLE SAINT EGREVE" },
  { externalId: "309", label: "BUT GUERANDE" },
  { externalId: "102", label: "BUT GUINGAMP" },
  { externalId: "101", label: "BUT GUÉRET" },
  { externalId: "357", label: "BUT HAGUENAU" },
  { externalId: "299", label: "BUT HAZEBROUCK" },
  { externalId: "354", label: "BUT HERBLAY" },
  { externalId: "324", label: "BUT HESDIN MARCONNE" },
  { externalId: "364", label: "BUT ISSOIRE" },
  { externalId: "322", label: "BUT ISSOUDUN" },
  { externalId: "271", label: "BUT JOIGNY" },
  { externalId: "328", label: "BUT JONZAC" },
  { externalId: "256", label: "BUT JUVIGNAC" },
  { externalId: "385", label: "BUT L'AIGLE" },
  { externalId: "311", label: "BUT LA FLÈCHE" },
  { externalId: "108", label: "BUT LA QUEUE EN BRIE" },
  { externalId: "112", label: "BUT LA ROCHE S/YON" },
  { externalId: "113", label: "BUT LA ROCHELLE" },
  { externalId: "109", label: "BUT LA RÉOLE" },
  { externalId: "114", label: "BUT LANGRES" },
  { externalId: "243", label: "BUT LAON" },
  { externalId: "116", label: "BUT LAVAL" },
  { externalId: "118", label: "BUT LE HAVRE" },
  { externalId: "119", label: "BUT LE MANS" },
  { externalId: "509", label: "BUT LE MANS NORD" },
  { externalId: "120", label: "BUT LE PUY EN VELAY" },
  { externalId: "379", label: "BUT LEERS" },
  { externalId: "122", label: "BUT LENS" },
  { externalId: "520", label: "BUT LES HERBIERS" },
  { externalId: "388", label: "BUT LESNEVEN" },
  { externalId: "123", label: "BUT LIBOURNE" },
  { externalId: "125", label: "BUT LIMOGES" },
  { externalId: "395", label: "BUT LIMOGES SUD" },
  { externalId: "126", label: "BUT LISIEUX" },
  { externalId: "300", label: "BUT LOCHES" },
  { externalId: "127", label: "BUT LONGWY" },
  { externalId: "128", label: "BUT LONS LE SAUNIER" },
  { externalId: "129", label: "BUT LORIENT LANESTER" },
  { externalId: "323", label: "BUT LOUDEAC" },
  { externalId: "292", label: "BUT LUCON" },
  { externalId: "273", label: "BUT LURE" },
  { externalId: "131", label: "BUT LYON/ST PRIEST" },
  { externalId: "132", label: "BUT MACON" },
  { externalId: "391", label: "BUT MADAGASCAR" },
  { externalId: "133", label: "BUT MANTES LA JOLIE" },
  { externalId: "278", label: "BUT MARMANDE" },
  { externalId: "264", label: "BUT MARMOUTIER" },
  { externalId: "136", label: "BUT MAUBEUGE" },
  { externalId: "301", label: "BUT MAYENNE" },
  { externalId: "517", label: "BUT MEAUX" },
  { externalId: "523", label: "BUT MENNECY (ORMOY)" },
  { externalId: "139", label: "BUT MENDE" },
  { externalId: "141", label: "BUT METZ" },
  { externalId: "377", label: "BUT MILLAU" },
  { externalId: "362", label: "BUT MIMIZAN" },
  { externalId: "143", label: "BUT MONT DE MARSAN" },
  { externalId: "145", label: "BUT MONTARGIS" },
  { externalId: "146", label: "BUT MONTAUBAN" },
  { externalId: "148", label: "BUT MONTCEAU LES MINES" },
  { externalId: "310", label: "BUT MONTEREAU" },
  { externalId: "150", label: "BUT MONTLUÇON" },
  { externalId: "151", label: "BUT MONTPELLIER" },
  { externalId: "149", label: "BUT MONTÉLIMAR" },
  { externalId: "397", label: "BUT MORTEAU" },
  { externalId: "153", label: "BUT MOULINS / YZEURE" },
  { externalId: "154", label: "BUT MULHOUSE" },
  { externalId: "280", label: "BUT NANCY" },
  { externalId: "156", label: "BUT NANTES / ST HERBLAIN" },
  { externalId: "157", label: "BUT NARBONNE" },
  { externalId: "158", label: "BUT NEMOURS" },
  { externalId: "263", label: "BUT NEUFCHATEAU" },
  { externalId: "390", label: "BUT NEUFCHATEL EN BRAY" },
  { externalId: "159", label: "BUT NEVERS" },
  { externalId: "160", label: "BUT NIMES" },
  { externalId: "161", label: "BUT NIORT" },
  { externalId: "162", label: "BUT NOGENT LE ROTROU" },
  { externalId: "302", label: "BUT NOYERS" },
  { externalId: "260", label: "BUT NOYON" },
  { externalId: "521", label: "BUT OLLIOULES" },
  { externalId: "329", label: "BUT OLORON-SAINTE-MARIE" },
  { externalId: "381", label: "BUT ORANGE" },
  { externalId: "355", label: "BUT ORGEVAL" },
  { externalId: "164", label: "BUT ORLÉANS" },
  { externalId: "511", label: "BUT OYONNAX" },
  { externalId: "165", label: "BUT PAMIERS" },
  { externalId: "347", label: "BUT PARTHENAY" },
  { externalId: "166", label: "BUT PAU" },
  { externalId: "261", label: "BUT PERONNE" },
  { externalId: "168", label: "BUT PERPIGNAN NORD" },
  { externalId: "169", label: "BUT PERPIGNAN SUD" },
  { externalId: "171", label: "BUT PITHIVIERS" },
  { externalId: "242", label: "BUT PLAISIR" },
  { externalId: "172", label: "BUT POITIERS" },
  { externalId: "287", label: "BUT PONT AUDEMER" },
  { externalId: "369", label: "BUT PONT L'EVEQUE" },
  { externalId: "173", label: "BUT PONTARLIER" },
  { externalId: "312", label: "BUT PONTCHATEAU" },
  { externalId: "174", label: "BUT PONTIVY" },
  { externalId: "175", label: "BUT PONTOISE-OSNY" },
  { externalId: "368", label: "BUT PORNIC" },
  { externalId: "330", label: "BUT PORTO VECCHIO" },
  { externalId: "176", label: "BUT PROVINS" },
  { externalId: "167", label: "BUT PÉRIGUEUX" },
  { externalId: "177", label: "BUT QUIMPER" },
  { externalId: "288", label: "BUT QUIMPERLÉ" },
  { externalId: "178", label: "BUT REDON" },
  { externalId: "179", label: "BUT REIMS/CORMONTREUIL" },
  { externalId: "180", label: "BUT REMIREMONT" },
  { externalId: "182", label: "BUT RENNES CHANTEPIE" },
  { externalId: "181", label: "BUT RENNES MELESSE" },
  { externalId: "370", label: "BUT REZE" },
  { externalId: "394", label: "BUT RIOM" },
  { externalId: "183", label: "BUT ROANNE" },
  { externalId: "184", label: "BUT ROCHEFORT" },
  { externalId: "248", label: "BUT RODEZ" },
  { externalId: "185", label: "BUT ROMANS" },
  { externalId: "186", label: "BUT ROMILLY" },
  { externalId: "187", label: "BUT ROMORANTIN" },
  { externalId: "363", label: "BUT RONCQ" },
  { externalId: "331", label: "BUT ROYAN" },
  { externalId: "332", label: "BUT RUFFEC" },
  { externalId: "313", label: "BUT SABLE SUR SARTHE" },
  { externalId: "192", label: "BUT SAINT AVOLD" },
  { externalId: "193", label: "BUT SAINT BRIEUC" },
  { externalId: "286", label: "BUT SAINT CYR SUR LOIRE" },
  { externalId: "195", label: "BUT SAINT DIZIER" },
  { externalId: "348", label: "BUT SAINT DIÉ" },
  { externalId: "198", label: "BUT SAINT ETIENNE" },
  { externalId: "199", label: "BUT SAINT FLOUR" },
  { externalId: "117", label: "BUT SAINT GAUDENS" },
  { externalId: "201", label: "BUT SAINT GIRONS" },
  { externalId: "303", label: "BUT SAINT JEAN D'ANGELY" },
  { externalId: "191", label: "BUT SAINT JEAN MAURIENNE" },
  { externalId: "333", label: "BUT SAINT JUNIEN" },
  { externalId: "202", label: "BUT SAINT LÔ" },
  { externalId: "304", label: "BUT SAINT MAIXENT" },
  { externalId: "203", label: "BUT SAINT MALO" },
  { externalId: "316", label: "BUT SAINT MARCEL" },
  { externalId: "507", label: "BUT SAINT MAXIMIN LA STE BAUME" },
  { externalId: "515", label: "BUT SAINT QUAY PERROS" },
  { externalId: "205", label: "BUT SAINT QUENTIN" },
  { externalId: "325", label: "BUT SAINT-AMAND-MONTROND" },
  { externalId: "204", label: "BUT SAINT-NAZAIRE" },
  { externalId: "372", label: "BUT SAINT-YRIEIX-LA-PERCHE" },
  { externalId: "196", label: "BUT SAINTE GENEVIEVE D/B" },
  { externalId: "197", label: "BUT SAINTES" },
  { externalId: "206", label: "BUT SALAISE" },
  { externalId: "501", label: "BUT SALON DE PROVENCE" },
  { externalId: "367", label: "BUT SARAN" },
  { externalId: "365", label: "BUT SARLAT" },
  { externalId: "207", label: "BUT SARREBOURG" },
  { externalId: "208", label: "BUT SARREGUEMINES" },
  { externalId: "209", label: "BUT SAUMUR/VIVY" },
  { externalId: "252", label: "BUT SECLIN" },
  { externalId: "314", label: "BUT SEGRE" },
  { externalId: "210", label: "BUT SELESTAT" },
  { externalId: "268", label: "BUT SEMUR" },
  { externalId: "211", label: "BUT SENS" },
  { externalId: "386", label: "BUT SISTERON" },
  { externalId: "253", label: "BUT SOISSONS" },
  { externalId: "214", label: "BUT STRASBOURG NORD" },
  { externalId: "217", label: "BUT TARBES" },
  { externalId: "315", label: "BUT TAVERS" },
  { externalId: "398", label: "BUT THIERS" },
  { externalId: "218", label: "BUT THIONVILLE" },
  { externalId: "219", label: "BUT THONON" },
  { externalId: "293", label: "BUT THOUARS" },
  { externalId: "270", label: "BUT TONNERRE" },
  { externalId: "220", label: "BUT TOULON" },
  { externalId: "221", label: "BUT TOULOUSE LABEGE" },
  { externalId: "222", label: "BUT TOULOUSE NORD" },
  { externalId: "223", label: "BUT TOULOUSE SUD" },
  { externalId: "224", label: "BUT TOURS" },
  { externalId: "189", label: "BUT TOURVILLE / ROUEN" },
  { externalId: "225", label: "BUT TROYES" },
  { externalId: "226", label: "BUT TULLE" },
  { externalId: "227", label: "BUT VALENCE" },
  { externalId: "228", label: "BUT VALENCIENNES" },
  { externalId: "229", label: "BUT VANNES" },
  { externalId: "508", label: "BUT VAUVERT" },
  { externalId: "230", label: "BUT VENDOME" },
  { externalId: "231", label: "BUT VERDUN" },
  { externalId: "265", label: "BUT VESOUL" },
  { externalId: "344", label: "BUT VICHY" },
  { externalId: "233", label: "BUT VIERZON" },
  { externalId: "234", label: "BUT VILLEFRANCHE ROUERGUE" },
  { externalId: "235", label: "BUT VILLEFRANCHE S/SAONE" },
  { externalId: "014", label: "BUT VILLENEUVE LOUBET" },
  { externalId: "237", label: "BUT VILLENEUVE S/LOT" },
  { externalId: "238", label: "BUT VIRE" },
  { externalId: "371", label: "BUT VITRE" },
  { externalId: "244", label: "BUT VOGLANS CHAMBERY" },
  { externalId: "239", label: "BUT VOIRON" },
  { externalId: "281", label: "BUT YVETOT" },
];
